import { FunctionComponent, useMemo } from 'react'

import useIsFmtRelevantMatchesEnabled from '@hooks/useIsFmtRelevantMatchesEnabled'
import useSportEntitySubscriptions from '@hooks/useSportEntitySubscriptions'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'
import RelevantMatches from '@components/RelevantMatches'

const MAX_COMPETITOR_IDS = 10

const validCompetitorId = (
  competitorId: string | undefined,
): competitorId is string => !!competitorId && competitorId !== '0'

const FmtRelevantMatches: FunctionComponent = () => {
  const isFmtRelevantMatchesEnabled = useIsFmtRelevantMatchesEnabled()

  const { data: sportEntitySubscriptions } = useSportEntitySubscriptions({
    entityType: 'competitor',
  })

  const validCompetitorIds = useMemo(() => {
    if (!sportEntitySubscriptions?.length) {
      return []
    }

    const validSubscribedCompetitorIds: string[] = []
    let examinedIndex = 0

    while (
      validSubscribedCompetitorIds.length < MAX_COMPETITOR_IDS &&
      examinedIndex < sportEntitySubscriptions.length
    ) {
      const competitorId = sportEntitySubscriptions[examinedIndex].sportradarId

      if (validCompetitorId(competitorId)) {
        validSubscribedCompetitorIds.push(competitorId)
      }

      examinedIndex += 1
    }

    return validSubscribedCompetitorIds
  }, [sportEntitySubscriptions])

  const shouldShowMatches =
    isFmtRelevantMatchesEnabled && validCompetitorIds.length > 0

  return shouldShowMatches ? (
    <RelevantMatches validCompetitorIds={validCompetitorIds} />
  ) : null
}

const widget = {
  kind: ['follow-my-team-relevant-matches'],
  component: FmtRelevantMatches,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
